import blockEmbedPlugin from 'markdown-it-block-embed';
import TwitchService from './VideoServices/TwitchService.js';
import CustomVideoService from './VideoServices/CustomVideoService.js';

/**
 * Returns Markdown-it plugin for use with instance::use(plugin, options) that
 * supports detects and outputs block level embeds such as videos and custom embed services.
 *
 * 1. Section headers will be given unique identifiers for use as internal anchors.
 *    For example, markdown:
 *
 *    @[youtube](lJIrF4YjHfQ)
 *
 *    will be rendered as HTML:
 *
 *    <div class="block-embed block-embed-service-youtube">
 *        <iframe type="text/html"
 *            width="640"
 *            height="390"
 *            src="//www.youtube.com/embed/lJIrF4YjHfQ"
 *            frameborder="0"
 *            webkitallowfullscreen mozallowfullscreen allowfullscreen>
 *        </iframe>
 *    </div>
 *
 * 2. There are two custom embed services: (1) Twitch and (2) a generic video URL.
 *    Both require a full URL to work. Will be rendered as
 *    <video> element wrapped in a <div> element and will use video.js
 *
 *    a. The Twitch service will be called in the markdown as  @[twitch](URL)
 *        The URL passed in can be either a link to a video or a channel.
 *        For example:
 *            Video Link: https://www.twitch.tv/videos/592037285
 *            Channel Link: https://www.twitch.tv/aws
 *
 *    b. The generic service will be called in the markdown as  @[video](URL)
 *       It can be used with any direct link to a video, but must end in a file type.
 *       For example:
 *            MP4 video hosted on S3: https://s3.amazonaws.com/[...].mp4
 *            M3U8 video: https://[...].m3u8
 *
 * 3. A defaultOptions object has been passed to all video services
 *    so the width and height of the videos displayed will be consistant
 *    across all of the provided video platforms.
 */

const defaultOptions = {
  width: '100%',
  height: '100%'
};
var BlockEmbed = (() => ({
  plugin: blockEmbedPlugin,
  options: {
    youtube: defaultOptions,
    prezi: defaultOptions,
    vimeo: defaultOptions,
    twitch: defaultOptions,
    video: defaultOptions,
    services: {
      twitch: TwitchService,
      video: CustomVideoService
    }
  }
}));

export { BlockEmbed as default };
